import {
  ShieldCheck, Waves, Dumbbell, Flower2, TreePine, Flower, Trophy, Wine,
  Coffee, Shirt, Footprints, Car, Users, Wrench, Sparkles, Bus,
} from "lucide-react";

const ICONS = [
  ShieldCheck, Waves, Dumbbell, Flower2, TreePine, Flower, Trophy, Wine,
  Coffee, Shirt, Footprints, Car, Users, Wrench, Sparkles, Bus,
];

export default function Amenities({ t }) {
  return (
    <section
      id="amenities"
      data-testid="amenities-section"
      className="relative bg-[#0A0A0A] py-24 lg:py-40 text-white overflow-hidden"
    >
      {/* Subtle grain */}
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
        }}
      />

      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-10 bg-[#BEAF87]" />
            <span className="text-[11px] uppercase tracking-[0.35em] text-[#BEAF87] font-[Barlow_Semi_Condensed] font-medium">
              {t.amenities.eyebrow}
            </span>
          </div>
          <h2
            data-testid="amenities-title"
            className="font-[Cormorant_Garamond] font-light text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
          >
            {t.amenities.title}
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {t.amenities.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={i}
                data-testid={`amenity-${i}`}
                className="group relative bg-[#0A0A0A] p-6 lg:p-8 transition-all duration-500 hover:bg-[#141414]"
              >
                <Icon
                  size={28}
                  className="text-[#BEAF87] mb-5 transition-transform duration-500 group-hover:scale-110"
                  strokeWidth={1.25}
                />
                <div className="text-white text-base lg:text-lg font-[Barlow_Semi_Condensed] font-medium tracking-wide">
                  {item.t}
                </div>
                <div className="mt-1 text-[13px] text-white/55 font-[Barlow_Semi_Condensed] leading-snug">
                  {item.d}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
